import { Auth0Provider } from '@auth0/auth0-react';
import { IconSprite } from '@beacon/ui/components';
import { PostHogProvider } from 'posthog-js/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { App, createAppRouter } from './App';
import { RootErrorBoundary } from './components/error/RootErrorBoundary';
import './globals.css';
import { posthog } from './lib/posthog';
import { installStaleChunkReload } from './lib/stale-chunk';

const AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN as string;
const AUTH0_CLIENT_ID = import.meta.env.VITE_AUTH0_CLIENT_ID as string;
const AUTH0_AUDIENCE = import.meta.env.VITE_AUTH0_AUDIENCE as string;

if (!AUTH0_DOMAIN || !AUTH0_CLIENT_ID) {
  throw new Error('VITE_AUTH0_DOMAIN and VITE_AUTH0_CLIENT_ID are required');
}

installStaleChunkReload();

const router = createAppRouter();

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <IconSprite />
    <RootErrorBoundary>
      <PostHogProvider client={posthog}>
        <Auth0Provider
          domain={AUTH0_DOMAIN}
          clientId={AUTH0_CLIENT_ID}
          authorizationParams={{
            redirect_uri: window.location.origin,
            audience: AUTH0_AUDIENCE,
          }}
          onRedirectCallback={(appState) => {
            router.navigate(appState?.returnTo || window.location.pathname, {
              replace: true,
            });
          }}
        >
          <App router={router} />
        </Auth0Provider>
      </PostHogProvider>
    </RootErrorBoundary>
  </React.StrictMode>,
);
